import React from "react"
import { Card, Form } from "react-bootstrap"

const SectionCard = ({ title, fields, onVisibilityChange, children }) => {
  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-capitalize text-dark">{title}</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={fields.isVisible}
          onChange={(e) => onVisibilityChange(e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {fields.isVisible && <Card.Body>{children}</Card.Body>}
    </Card>
  )
}

export default SectionCard
